// Expanded mapping templates based on values used in SfsProvider.js
import {
  FinancialStatementCategoryItem,
  FinancialStatementDebtItem,
} from "./financial";
import { toMoney } from "./money";
import { FlexibleOther } from "../../api/dto/FinancialStatement";

const DefaultValue = Number(0).toFixed(2);
const DefaultFrequency = "M" as const;

export const buildIncome = (income: any): FinancialStatementCategoryItem[] => [
  {
    parent: "Income",
    category: "Income",
    title: "Salary/Wage",
    key: "customerSalaryWage",
    value: toMoney(income?.customerSalaryWageAmount ?? DefaultValue),
    frequency: income?.customerSalaryWageFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Income",
    title: "Other earnings",
    key: "otherEarnings",
    value: toMoney(income?.otherEarningsAmount ?? DefaultValue),
    frequency: income?.otherEarningsFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Income",
    title: "Partner salary/wage",
    key: "partnerSalaryWage",
    value: toMoney(income?.partnerSalaryWageAmount ?? DefaultValue),
    frequency: income?.partnerSalaryWageFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Carers allowance",
    key: "carersAllowance",
    value: toMoney(income?.carersAllowanceAmount ?? DefaultValue),
    frequency: income?.carersAllowanceFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Child benefit",
    key: "childBenefit",
    value: toMoney(income?.childBenefitAmount ?? DefaultValue),
    frequency: income?.childBenefitFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Child tax credit",
    key: "childTaxCredit",
    value: toMoney(income?.childTaxCreditAmount ?? DefaultValue),
    frequency: income?.childTaxCreditFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Children under 16",
    key: "childrenUnder16",
    value: toMoney(income?.childrenUnder16Amount ?? DefaultValue),
    frequency: income?.childrenUnder16Freq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Council tax support",
    key: "councilTaxSupport",
    value: toMoney(income?.councilTaxSupportAmount ?? DefaultValue),
    frequency: income?.councilTaxSupportFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Disability benefits",
    key: "disabilityBenefits",
    value: toMoney(income?.disabilityBenefitsAmount ?? DefaultValue),
    frequency: income?.disabilityBenefitsFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Employment & support allowance / SSP",
    key: "emplymentSupportAllowanceorSSP",
    value: toMoney(income?.emplymentSupportAllowanceorSSPAmount ?? DefaultValue),
    frequency: income?.emplymentSupportAllowanceorSSPFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Income support",
    key: "incomeSupport",
    value: toMoney(income?.incomeSupportAmount ?? DefaultValue),
    frequency: income?.incomeSupportFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Jobseekers allowance (contribution based)",
    key: "jobseekersAllowanceContributionBased",
    value: toMoney(income?.jobseekersAllowanceContributionBasedAmount ?? DefaultValue),
    frequency: income?.jobseekersAllowanceContributionBasedFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Jobseekers allowance (income based)",
    key: "jobseekersAllowanceIncomeBased",
    value: toMoney(income?.jobseekersAllowanceIncomeBasedAmount ?? DefaultValue),
    frequency: income?.jobseekersAllowanceIncomeBasedFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Local housing allowance / Housing benefits",
    key: "localHousingAllowanceHousingBenefit",
    value: toMoney(income?.localHousingAllowanceHousingBenefitAmount ?? DefaultValue),
    frequency: income?.localHousingAllowanceHousingBenefitFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Other benefits tax credits",
    key: "otherBenefitsTaxCredits",
    value: toMoney(income?.otherBenefitsTaxCreditsAmount ?? DefaultValue),
    frequency: income?.otherBenefitsTaxCreditsFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Universal credit",
    key: "universalCredit",
    value: toMoney(income?.universalCreditAmount ?? DefaultValue),
    frequency: income?.universalCreditFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Benefits",
    title: "Working tax credit",
    key: "workingTaxCredit",
    value: toMoney(income?.workingTaxCreditAmount ?? DefaultValue),
    frequency: income?.workingTaxCreditFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Pensions",
    title: "Other pensions",
    key: "otherPensions",
    value: toMoney(income?.otherPensionsAmount ?? DefaultValue),
    frequency: income?.otherPensionsFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Pensions",
    title: "Pensions credit",
    key: "pensionCredit",
    value: toMoney(income?.pensionCreditAmount ?? DefaultValue),
    frequency: income?.pensionCreditFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Pensions",
    title: "Private or work pensions",
    key: "privateorWorkPensions",
    value: toMoney(income?.privateorWorkPensionsAmount ?? DefaultValue),
    frequency: income?.privateorWorkPensionsFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Pensions",
    title: "State pensions",
    key: "statePensions",
    value: toMoney(income?.statePensionsAmount ?? DefaultValue),
    frequency: income?.statePensionsFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Other",
    title: "Boarders or lodgers",
    key: "boardersorLodgers",
    value: toMoney(income?.boardersorLodgersAmount ?? DefaultValue),
    frequency: income?.boardersorLodgersFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Other",
    title: "Maintenance or child support",
    key: "maintenanceorChildSupport",
    value: toMoney(income?.maintenanceorChildSupportAmount ?? DefaultValue),
    frequency: income?.maintenanceorChildSupportFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Other",
    title: "Non-dependents contributions",
    key: "nonDependentsContributions",
    value: toMoney(income?.nonDependentsContributionsAmount ?? DefaultValue),
    frequency: income?.nonDependentsContributionsFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Other",
    title: "Other income",
    key: "otherIncome",
    value: toMoney(income?.otherIncomeAmount ?? DefaultValue),
    frequency: income?.otherIncomeFreq ?? DefaultFrequency,
  },
  {
    parent: "Income",
    category: "Other",
    title: "Student loans & grants",
    key: "studentLoansandGrants",
    value: toMoney(income?.studentLoansandGrantsAmount ?? DefaultValue),
    frequency: income?.studentLoansandGrantsFreq ?? DefaultFrequency,
  },
];

export const buildFixed = (fixed: any): FinancialStatementCategoryItem[] => [
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "Appliance & furniture rental",
    key: "applianceFurnitureRental",
    value: toMoney(fixed?.applianceFurnitureRentalAmount ?? DefaultValue),
    frequency: fixed?.applianceFurnitureRentalFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "Council tax/rates",
    key: "councilTaxRates",
    value: toMoney(fixed?.councilTaxRatesAmount ?? DefaultValue),
    frequency: fixed?.councilTaxRatesFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "Ground rent & service charges",
    key: "groundRentServiceCharges",
    value: toMoney(fixed?.groundRentServiceChargesAmount ?? DefaultValue),
    frequency: fixed?.groundRentServiceChargesFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "Other costs",
    key: "homeOtherCosts",
    value: toMoney(fixed?.homeOtherCostsAmount ?? DefaultValue),
    frequency: fixed?.homeOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "Mortgage",
    key: "mortgage",
    value: toMoney(fixed?.mortgageAmount ?? DefaultValue),
    frequency: fixed?.mortgageFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "Mortgage endowment",
    key: "mortgageEndowment",
    value: toMoney(fixed?.mortgageEndowmentAmount ?? DefaultValue),
    frequency: fixed?.mortgageEndowmentFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "Rent",
    key: "rent",
    value: toMoney(fixed?.rentAmount ?? DefaultValue),
    frequency: fixed?.rentFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "Secured loans",
    key: "securedLoans",
    value: toMoney(fixed?.securedLoansAmount ?? DefaultValue),
    frequency: fixed?.securedLoansFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Home & Contents",
    title: "TV licence",
    key: "tvLicence",
    value: toMoney(fixed?.tvLicenceAmount ?? DefaultValue),
    frequency: fixed?.tvLicenceFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Care & Health",
    title: "Adult-care costs",
    key: "adultCareCosts",
    value: toMoney(fixed?.adultCareCostsAmount ?? DefaultValue),
    frequency: fixed?.adultCareCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Care & Health",
    title: "Other costs",
    key: "careOtherCosts",
    value: toMoney(fixed?.careOtherCostsAmount ?? DefaultValue),
    frequency: fixed?.careOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Care & Health",
    title: "Child maintenance",
    key: "childMaintenanceorChildSupport",
    value: toMoney(fixed?.childMaintenanceorChildSupportAmount ?? DefaultValue),
    frequency: fixed?.childMaintenanceorChildSupportFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Care & Health",
    title: "Childcare costs",
    key: "childcareCosts",
    value: toMoney(fixed?.childcareCostsAmount ?? DefaultValue),
    frequency: fixed?.childcareCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Care & Health",
    title: "Dentistry & opticians",
    key: "dentistryandOpticians",
    value: toMoney(fixed?.dentistryandOpticiansAmount ?? DefaultValue),
    frequency: fixed?.dentistryandOpticiansFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Care & Health",
    title: "Prescriptions & medicine",
    key: "prescriptionsandMedicines",
    value: toMoney(fixed?.prescriptionsandMedicinesAmount ?? DefaultValue),
    frequency: fixed?.prescriptionsandMedicinesFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Pensions & Insurance",
    title: "Buildings & content",
    key: "buildingsandContent",
    value: toMoney(fixed?.buildingsandContentAmount ?? DefaultValue),
    frequency: fixed?.buildingsandContentFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Pensions & Insurance",
    title: "Health insurance",
    key: "healthInsurance",
    value: toMoney(fixed?.healthInsuranceAmount ?? DefaultValue),
    frequency: fixed?.healthInsuranceFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Pensions & Insurance",
    title: "Life insurance",
    key: "lifeInsurance",
    value: toMoney(fixed?.lifeInsuranceAmount ?? DefaultValue),
    frequency: fixed?.lifeInsuranceFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Pensions & Insurance",
    title: "Mortgage payment protection",
    key: "mortgagePaymentProtection",
    value: toMoney(fixed?.mortgagePaymentProtectionAmount ?? DefaultValue),
    frequency: fixed?.mortgagePaymentProtectionFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Pensions & Insurance",
    title: "Other costs",
    key: "pensionOtherCosts",
    value: toMoney(fixed?.pensionOtherCostsAmount ?? DefaultValue),
    frequency: fixed?.pensionOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Pensions & Insurance",
    title: "Pension payments",
    key: "pensionPayments",
    value: toMoney(fixed?.pensionPaymentsAmount ?? DefaultValue),
    frequency: fixed?.pensionPaymentsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Utilities",
    title: "Electricity",
    key: "electricity",
    value: toMoney(fixed?.electricityAmount ?? DefaultValue),
    frequency: fixed?.electricityFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Utilities",
    title: "Gas",
    key: "gas",
    value: toMoney(fixed?.gasAmount ?? DefaultValue),
    frequency: fixed?.gasFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Utilities",
    title: "Other costs (coal, oil etc.)",
    key: "utilOtherCosts",
    value: toMoney(fixed?.utilOtherCostsAmount ?? DefaultValue),
    frequency: fixed?.utilOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Utilities",
    title: "Other expenditure",
    key: "utilOtherExpenditure",
    value: toMoney(fixed?.utilOtherExpenditureAmount ?? DefaultValue),
    frequency: fixed?.utilOtherExpenditureFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Water",
    title: "Water supply",
    key: "waterSupply",
    value: toMoney(fixed?.waterSupplyAmount ?? DefaultValue),
    frequency: fixed?.waterSupplyFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Water",
    title: "Water waste",
    key: "waterWaste",
    value: toMoney(fixed?.waterWasteAmount ?? DefaultValue),
    frequency: fixed?.waterWasteFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "School Costs",
    title: "After-school clubs & school trips",
    key: "afterSchoolClubsandSchoolTrips",
    value: toMoney(fixed?.afterSchoolClubsandSchoolTripsAmount ?? DefaultValue),
    frequency: fixed?.afterSchoolClubsandSchoolTripsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "School Costs",
    title: "Other costs",
    key: "schoolOtherCosts",
    value: toMoney(fixed?.schoolOtherCostsAmount ?? DefaultValue),
    frequency: fixed?.schoolOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "School Costs",
    title: "School uniform",
    key: "schoolUniform",
    value: toMoney(fixed?.schoolUniformAmount ?? DefaultValue),
    frequency: fixed?.schoolUniformFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Professional Costs",
    title: "Professional fees",
    key: "prefessionalFees",
    value: toMoney(fixed?.prefessionalFeesAmount ?? DefaultValue),
    frequency: fixed?.prefessionalFeesFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Professional Costs",
    title: "Professional courses",
    key: "professionalCourses",
    value: toMoney(fixed?.professionalCoursesAmount ?? DefaultValue),
    frequency: fixed?.professionalCoursesFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Professional Costs",
    title: "Other costs",
    key: "profressionalOtherCosts",
    value: toMoney(fixed?.profressionalOtherCostsAmount ?? DefaultValue),
    frequency: fixed?.profressionalOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Professional Costs",
    title: "Union fees",
    key: "unionFees",
    value: toMoney(fixed?.unionFeesAmount ?? DefaultValue),
    frequency: fixed?.unionFeesFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Transport & Travel",
    title: "Breakdown cover",
    key: "breakdownCover",
    value: toMoney(fixed?.breakdownCoverAmount ?? DefaultValue),
    frequency: fixed?.breakdownCoverFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Transport & Travel",
    title: "Car insurance",
    key: "carInsurance",
    value: toMoney(fixed?.carInsuranceAmount ?? DefaultValue),
    frequency: fixed?.carInsuranceFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Transport & Travel",
    title: "Fuel, parking, toll charges",
    key: "fuelParkingTollCharges",
    value: toMoney(fixed?.fuelParkingTollChargesAmount ?? DefaultValue),
    frequency: fixed?.fuelParkingTollChargesFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Transport & Travel",
    title: "Hire purchase",
    key: "hirePurchase",
    value: toMoney(fixed?.hirePurchaseAmount ?? DefaultValue),
    frequency: fixed?.hirePurchaseFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Transport & Travel",
    title: "MOT & ongoing maintenance",
    key: "moTandongoingMaintenance",
    value: toMoney(fixed?.moTandongoingMaintenanceAmount ?? DefaultValue),
    frequency: fixed?.moTandongoingMaintenanceFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Transport & Travel",
    title: "Public transport",
    key: "publicTransport",
    value: toMoney(fixed?.publicTransportAmount ?? DefaultValue),
    frequency: fixed?.publicTransportFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Transport & Travel",
    title: "Road tax",
    key: "roadTax",
    value: toMoney(fixed?.roadTaxAmount ?? DefaultValue),
    frequency: fixed?.roadTaxFreq ?? DefaultFrequency,
  },
  {
    parent: "Fixed Expenditure",
    category: "Transport & Travel",
    title: "Other costs (inc taxis)",
    key: "transportOtherCosts",
    value: toMoney(fixed?.transportOtherCostsAmount ?? DefaultValue),
    frequency: fixed?.transportOtherCostsFreq ?? DefaultFrequency,
  },
];

export const buildFixedOther = (
  fixed: FlexibleOther[],
): FinancialStatementCategoryItem[] => [
  ...((fixed?.map((item, idx: number) => ({
    parent: "Fixed Expenditure",
    category: "Other",
    title: item.label,
    key: `fixedOther${idx + 1}`,
    value: toMoney(item.amount ?? DefaultValue),
    frequency: item.frequency ?? DefaultFrequency,
  })) ?? []) as FinancialStatementCategoryItem[]),
];

export const buildFlexible = (
  flexible: any,
): FinancialStatementCategoryItem[] => [
  {
    parent: "Flexible Expenditure",
    category: "Communications & Leisure",
    title: "Other costs",
    key: "communicationsOtherCosts",
    value: toMoney(flexible?.communicationsOtherCostsAmount ?? DefaultValue),
    frequency: flexible?.communicationsOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Communications & Leisure",
    title: "Gifts (e.g. birthdays)",
    key: "gifts",
    value: toMoney(flexible?.giftsAmount ?? DefaultValue),
    frequency: flexible?.giftsFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Communications & Leisure",
    title: "Hobbies, leisure or sport",
    key: "hobbiesLeisureOrSport",
    value: toMoney(flexible?.hobbiesLeisureOrSportAmount ?? DefaultValue),
    frequency: flexible?.hobbiesLeisureOrSportFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Communications & Leisure",
    title: "Home phone",
    key: "homePhoneInternetTVPackage",
    value: toMoney(flexible?.homePhoneInternetTVPackageAmount ?? DefaultValue),
    frequency: flexible?.homePhoneInternetTVPackageFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Communications & Leisure",
    title: "Mobile phone",
    key: "mobilePhone",
    value: toMoney(flexible?.mobilePhoneAmount ?? DefaultValue),
    frequency: flexible?.mobilePhoneFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Communications & Leisure",
    title: "Newspapers, magazines etc.",
    key: "newspapersMagazinesStationaryPostage",
    value: toMoney(flexible?.newspapersMagazinesStationaryPostageAmount ?? DefaultValue),
    frequency: flexible?.newspapersMagazinesStationaryPostageFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Communications & Leisure",
    title: "Pocket money",
    key: "pocketMoney",
    value: toMoney(flexible?.pocketMoneyAmount ?? DefaultValue),
    frequency: flexible?.pocketMoneyFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "Alcohol",
    key: "alcohol",
    value: toMoney(flexible?.alcoholAmount ?? DefaultValue),
    frequency: flexible?.alcoholFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "Groceries",
    key: "groceries",
    value: toMoney(flexible?.groceriesAmount ?? DefaultValue),
    frequency: flexible?.groceriesFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "House repairs & maintenance",
    key: "houseRepairsAndMaintenance",
    value: toMoney(flexible?.houseRepairsAndMaintenanceAmount ?? DefaultValue),
    frequency: flexible?.houseRepairsAndMaintenanceFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "Other costs",
    key: "housekeepingOtherCosts",
    value: toMoney(flexible?.housekeepingOtherCostsAmount ?? DefaultValue),
    frequency: flexible?.housekeepingOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "Laundry & dry cleaning",
    key: "laundryandDryCleaning",
    value: toMoney(flexible?.laundryandDryCleaningAmount ?? DefaultValue),
    frequency: flexible?.laundryandDryCleaningFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "Nappies & baby items",
    key: "nappiesAndBabyItems",
    value: toMoney(flexible?.nappiesAndBabyItemsAmount ?? DefaultValue),
    frequency: flexible?.nappiesAndBabyItemsFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "School meals & work meals",
    key: "schoolMealsAndMealsAtWork",
    value: toMoney(flexible?.schoolMealsAndMealsAtWorkAmount ?? DefaultValue),
    frequency: flexible?.schoolMealsAndMealsAtWorkFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "Smoking products",
    key: "smokingProducts",
    value: toMoney(flexible?.smokingProductsAmount ?? DefaultValue),
    frequency: flexible?.smokingProductsFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Food & Housekeeping",
    title: "Vet bills",
    key: "vetBillsandPetInsurance",
    value: toMoney(flexible?.vetBillsandPetInsuranceAmount ?? DefaultValue),
    frequency: flexible?.vetBillsandPetInsuranceFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Personal Costs",
    title: "Clothing & footwear",
    key: "clothingandFootwear",
    value: toMoney(flexible?.clothingandFootwearAmount ?? DefaultValue),
    frequency: flexible?.clothingandFootwearFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Personal Costs",
    title: "Hairdressing",
    key: "hairdressing",
    value: toMoney(flexible?.hairdressingAmount ?? DefaultValue),
    frequency: flexible?.hairdressingFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Personal Costs",
    title: "Other costs",
    key: "personalOtherCosts",
    value: toMoney(flexible?.personalOtherCostsAmount ?? DefaultValue),
    frequency: flexible?.personalOtherCostsFreq ?? DefaultFrequency,
  },
  {
    parent: "Flexible Expenditure",
    category: "Personal Costs",
    title: "Toiletries",
    key: "toiletries",
    value: toMoney(flexible?.toiletriesAmount ?? DefaultValue),
    frequency: flexible?.toiletriesFreq ?? DefaultFrequency,
  },
];

export const buildDebts = (debt: any): FinancialStatementDebtItem[] => [
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Council tax",
    key: "councilTaxArrears",
    balance: toMoney(debt?.councilTaxArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.councilTaxArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.councilTaxArrearsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Hire purchase",
    key: "hirePurchase",
    balance: toMoney(debt?.hirePurchaseOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.hirePurchaseRepaymentAmount ?? DefaultValue),
    frequency: debt?.hirePurchaseFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Maintenance",
    key: "maintenance",
    balance: toMoney(debt?.maintenanceOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.maintenanceRepaymentAmount ?? DefaultValue),
    frequency: debt?.maintenanceFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Magistrate fines",
    key: "migistrateFines",
    balance: toMoney(debt?.migistrateFinesOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.migistrateFinesRepaymentAmount ?? DefaultValue),
    frequency: debt?.migistrateFinesFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Mortgage arrears",
    key: "mortgageArrears",
    balance: toMoney(debt?.mortgageArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.mortgageArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.mortgageArrearsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Other arrears",
    key: "otherArrears",
    balance: toMoney(debt?.otherArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.otherArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.otherArrearsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Other secured loans",
    key: "otherSecuredLoans",
    balance: toMoney(debt?.otherSecuredLoansOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.otherSecuredLoansRepaymentAmount ?? DefaultValue),
    frequency: debt?.otherSecuredLoansFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Rent arrears",
    key: "rentArrears",
    balance: toMoney(debt?.rentArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.rentArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.rentArrearsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Priority Debts",
    title: "Utilities arrears",
    key: "utilitiesArrears",
    balance: toMoney(debt?.utilitiesArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.utilitiesArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.utilitiesArrearsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Non Priority Debts",
    title: "Credit card arrears",
    key: "creditCardArrears",
    balance: toMoney(debt?.creditCardArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.creditCardArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.creditCardArrearsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Non Priority Debts",
    title: "Other debt arrears",
    key: "otherDebtArrears",
    balance: toMoney(debt?.otherDebtArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.otherDebtArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.otherDebtArrearsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Non Priority Debts",
    title: "Overdrafts",
    key: "overdrafts",
    balance: toMoney(debt?.overdraftsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.overdraftsRepaymentAmount ?? DefaultValue),
    frequency: debt?.overdraftsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Non Priority Debts",
    title: "Store card arrears",
    key: "storeCardArrears",
    balance: toMoney(debt?.storeCardArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.storeCardArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.storeCardArrearsFreq ?? DefaultFrequency,
  },
  {
    parent: "Additional Debt",
    category: "Non Priority Debts",
    title: "Unsecured loan arrears",
    key: "unsecuredLoansArrears",
    balance: toMoney(debt?.unsecuredLoansArrearsOutstandingAmount ?? DefaultValue),
    value: toMoney(debt?.unsecuredLoansArrearsRepaymentAmount ?? DefaultValue),
    frequency: debt?.unsecuredLoansArrearsFreq ?? DefaultFrequency,
  },
];

export function dumpSection(
  section: FinancialStatementCategoryItem[] | FinancialStatementDebtItem[],
  debts = false,
): Record<string, string> {
  return section.reduce((acc, item) => {
    acc[`${item.key}Freq`] = item.frequency;
      if (!debts) {
          acc[`${item.key}Amount`] = item.value;
      }
      else {
      acc[`${item.key}RepaymentAmount`] = item.value;
      acc[`${item.key}OutstandingAmount`] = item.balance ?? 0;
    }
    return acc;
  }, {});
}
